import { useState, useRef } from "react";
import { motion } from "framer-motion";

interface GradientBorderCardProps {
  children: React.ReactNode;
  index?: number;
  className?: string;
}

const GradientBorderCard = ({ children, index = 0, className = "" }: GradientBorderCardProps) => {
  const cardRef = useRef<HTMLDivElement>(null);
  const [gradientPos, setGradientPos] = useState({ x: 50, y: 50 });
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!cardRef.current) return;
    const rect = cardRef.current.getBoundingClientRect();
    const x = ((e.clientX - rect.left) / rect.width) * 100;
    const y = ((e.clientY - rect.top) / rect.height) * 100;
    setGradientPos({ x, y });
  };

  return (
    <motion.div
      ref={cardRef}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ delay: index * 0.1 }}
      onMouseMove={handleMouseMove}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className="relative p-[1px] rounded-2xl group transition-all duration-500"
      style={{
        background: isHovered
          ? `radial-gradient(circle at ${gradientPos.x}% ${gradientPos.y}%, rgba(255,188,0,0.3), transparent 70%)`
          : 'rgba(255,255,255,0.05)',
      }}

    >
      <div
        className={`rounded-2xl bg-[#272727]/50 backdrop-blur-sm h-full border border-white/5 ${className}`}
        style={{ borderColor: isHovered ? 'rgba(255,188,0,0.5)' : undefined }}
      >
        {children}
      </div>
    </motion.div>
  );
};

export default GradientBorderCard;
